import React from 'react'
import { Dialog } from '@headlessui/react'
import QuickContactForm from './QuickContactForm'
import { FormField } from './index'

interface QuickContactModalProps {
    isOpen: boolean
    onClose: () => void
    onSubmitSuccess?: () => void
    title?: string
    subtitle?: string
    formUrl?: string
    direction?: 'rtl' | 'ltr' | 'auto'
    cta?: {
        label: string
    }
    formFields?: Array<FormField>
    confirmationTitle?: {
        title: string
        subtitle: string
        description: string
    }
    confirmationMessageCTA?: {
        title: string
        url: string
    }
}

export default function QuickContactModal({
    isOpen,
    onClose,
    onSubmitSuccess,
    title,
    subtitle,
    formUrl,
    formFields,
    confirmationTitle,
    confirmationMessageCTA,
    direction,
    cta,
}: QuickContactModalProps) {
    const handleSubmitSuccess = () => {
        onSubmitSuccess?.()
        onClose()
    }

    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50" dir={direction}>
            {/* Backdrop */}
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" aria-hidden="true" />

            {/* Full-screen container to center the panel */}
            <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel className="mx-auto w-full max-w-xl rounded-2xl bg-[#0B1C39] p-8">
                    <div className="mb-6 flex items-start justify-between">
                        <div>
                            <Dialog.Title className="text-2xl font-bold text-white">{title}</Dialog.Title>
                            {subtitle && (
                                <Dialog.Description className="mt-2 text-white/80">{subtitle}</Dialog.Description>
                            )}
                        </div>
                        <button onClick={onClose} className="text-white/60 transition-colors hover:text-white/90">
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>

                    <QuickContactForm
                        formUrl={formUrl}
                        formFields={formFields}
                        confirmationTitle={confirmationTitle}
                        confirmationMessageCTA={confirmationMessageCTA}
                        onSubmitSuccess={handleSubmitSuccess}
                        cta={cta}
                    />
                </Dialog.Panel>
            </div>
        </Dialog>
    )
}
